import { Laya } from "../../../../Laya";
import { Laya3DRender } from "../../../d3/RenderObjs/Laya3DRender";
import { WebBaseRenderNode } from "../../RenderModuleData/WebModuleData/3D/WebBaseRenderNode";
import { WebSceneRenderManager } from "../../RenderModuleData/WebModuleData/3D/WebScene3DRenderManager";
import { WebGLSetRenderData, WebGLSetShaderDefine } from "../RenderDevice/WebGLRenderCMD";
import { WebGLInstanceRenderBatch } from "./WebGLInstanceRenderBatch";
import { WebGLInstanceRenderElement3D } from "./WebGLInstanceRenderElement3D";
import { WebGLRender3DProcess } from "./WebGLRender3DProcess";
import { WebGLBlitQuadCMDData, WebGLDrawElementCMDData, WebGLDrawNodeCMDData, WebGLSetRenderTargetCMD, WebGLSetViewportCMD } from "./WebGLRenderCMD/WebGL3DRenderCMD";
import { WebGLRenderContext3D } from "./WebGLRenderContext3D";
import { WebGLRenderElement3D } from "./WebGLRenderElement3D";
import { WebGLSkinRenderElement3D } from "./WebGLSkinRenderElement3D";
WebBaseRenderNode.BaseRenderNodeClass = WebBaseRenderNode;
export class WebGL3DRenderPassFactory {
    createInstanceBatch() {
        return new WebGLInstanceRenderBatch();
    }
    createSetRenderDataCMD() {
        return new WebGLSetRenderData();
    }
    createSetShaderDefineCMD() {
        return new WebGLSetShaderDefine();
    }
    createDrawNodeCMDData() {
        return new WebGLDrawNodeCMDData();
    }
    createBlitQuadCMDData() {
        return new WebGLBlitQuadCMDData();
    }
    createDrawElementCMDData() {
        return new WebGLDrawElementCMDData();
    }
    createSetViewportCMD() {
        return new WebGLSetViewportCMD();
    }
    createSetRenderTargetCMD() {
        return new WebGLSetRenderTargetCMD();
    }
    createSceneRenderManager() {
        return new WebSceneRenderManager();
    }
    createSkinRenderElement() {
        return new WebGLSkinRenderElement3D();
    }
    createRenderContext3D() {
        let context = new WebGLRenderContext3D();
        return context;
    }
    createRenderElement3D() {
        return new WebGLRenderElement3D();
    }
    createInstanceRenderElement3D() {
        return WebGLInstanceRenderElement3D.create();
    }
    createRender3DProcess() {
        return new WebGLRender3DProcess();
    }
}
Laya.addBeforeInitCallback(() => {
    if (!Laya3DRender.Render3DPassFactory)
        Laya3DRender.Render3DPassFactory = new WebGL3DRenderPassFactory();
});
